import {FeatureToggles as IApiFeatureToggles} from 'api/core';

export const featureToggleAggregateMap = ({is_enabled, ...restOptions}: IApiFeatureToggles) => ({
  ...restOptions,
  isEnabled: is_enabled,
});
